import { css } from "styled-components";

import { inlineOverlayZIndex } from "../foundations/popover";

/**
 * c6 tooltip 버블의 공용 **시각 표면**(색·radius·타이포·폭·z). 위치(`position`)·표시 토글·페이드는
 * 소비 측이 얹는다. `Tooltip`(per-trigger)과 `TruncationTooltipHost`(공유 단일 버블)가 같은 룩을
 * 쓰도록 한 곳에서 소유한다(재사용 규칙 §3 — 중복 시각 금지).
 */
export const tooltipBubbleSurfaceCss = css`
  justify-content: center;
  align-items: center;
  z-index: ${inlineOverlayZIndex.tooltip};
  width: max-content;
  max-width: 16rem;
  padding: 0.3rem 0.5rem;
  border-radius: ${({ theme }) => theme.shape.radius.tooltip};
  font-size: ${({ theme }) => theme.typography.size.caption};
  white-space: normal;
  /* 소비처는 버블을 flex 로 띄운다. 그래서 텍스트는 익명 flex item 이 되고, 최소 폭은 min-content 다.
     break-word 는 min-content 폭을 줄이지 않는다. 그래서 공백 없는 긴 값(식별자·경로)이 max-width 를
     넘는다. anywhere 는 공백에서 먼저 줄을 바꾼다. 그래도 넘치는 값만 값 중간에서 줄을 바꾼다. */
  overflow-wrap: anywhere;
  background-color: ${({ theme }) => theme.color.bg.control.primaryActive};
  color: ${({ theme }) => theme.color.text.onControl};
`;
